module.exports = __webpack_public_path__ + "img/java.930fb030.svg";